import { useNavigate } from "react-router-dom";

import Style from "./style";

import MainHeader from "widget/MainHeader";
import Search from "widget/Search";
import Pagenation from "widget/Pagenation";

import useGetMyEventList from "entity/event/useGetMyEventList";
import useGetMyFranchise from "entity/franchise/useGetMyFranchise";

import TStyle from "shared/style/tableStyle";
import timestampCalculator from "shared/lib/timestampCalculator";
import { convertEventTypeAsName } from "shared/constant/lookup/eventType";
import { convertEventStateAsName } from "shared/constant/lookup/eventState";
import { convertProGradeAsName } from "shared/constant/lookup/proGrade";
import useRoleCookie from "shared/model/useRoleCookie";
import { ROLE_FRANCHISE_MANAGER } from "shared/constant/lookup/role";

const MyEventList = () => {
  const navigate = useNavigate();

  const [myEventList] = useGetMyEventList();
  const [roleCookie] = useRoleCookie();

  const btnList = [
    {
      label: "생성",
      clickEvent: () => navigate("/event/create"),
      deactive: false,
    },
  ];

  const sizeList = [
    "long",
    "short",
    "expand",
    "medium",
    "medium",
    "medium",
    "long",
  ];
  const tableHeadList = [
    "대회 날짜",
    "IDX",
    "대회 이름",
    ...(roleCookie === ROLE_FRANCHISE_MANAGER ? ["대회 이름"] : []),
    "대회 종류",
    "요구 프로 자격",
    "상태",
    "생성 날짜",
  ];

  return (
    <Style.Wrapper>
      <MainHeader btnList={btnList}>대회 목록</MainHeader>
      <Search placeholder="대회 이름에 포함되는 글자로 검색" />

      <TStyle.TableDiv>
        <TStyle.TableRow $title>
          {tableHeadList.map((elem, index) => (
            <TStyle.Data $title $size={sizeList[index]}>
              {elem}
            </TStyle.Data>
          ))}
        </TStyle.TableRow>
        {myEventList?.data?.event_list?.map((elem, index) => (
          <TStyle.TableRow
            $odd={index % 2 === 1}
            onClick={() => navigate(`/event/${elem?.idx}/detail`)}
          >
            <TStyle.Data $size={sizeList[0]}>
              {timestampCalculator(elem?.date)}
            </TStyle.Data>
            <TStyle.Data $size={sizeList[1]}>{elem?.idx}</TStyle.Data>
            <TStyle.Data $size={sizeList[2]}>{elem?.name}</TStyle.Data>
            {roleCookie === ROLE_FRANCHISE_MANAGER && (
              <TStyle.Data $size={sizeList[3]}>{elem?.store_name}</TStyle.Data>
            )}
            <TStyle.Data $size={sizeList[4]}>
              {convertEventTypeAsName[elem?.event_type_flag]}
            </TStyle.Data>
            <TStyle.Data $size={sizeList[5]}>
              {convertProGradeAsName[elem?.pro_grade_flag]}
            </TStyle.Data>
            <TStyle.Data $size={sizeList[6]}>
              {convertEventStateAsName[elem?.event_state_flag]}
            </TStyle.Data>
            <TStyle.Data $size={sizeList[7]}>
              {timestampCalculator(elem?.created_at)}
            </TStyle.Data>
          </TStyle.TableRow>
        ))}
      </TStyle.TableDiv>

      <Pagenation maxPage={myEventList?.data?.max_page} />
    </Style.Wrapper>
  );
};

export default MyEventList;
